import * as Diag from "VSS/Diag";
import * as Q from "q";
import { WebPageDataService } from "VSS/Contributions/Services";
import { getService } from "VSS/Service";
import * as PlatformContracts from "VSS/Common/Contracts/Platform";
import * as VssContext from "VSS/Context";
import { TfsContext } from "Presentation/Scripts/TFS/TFS.Host.TfsContext";
import * as StringUtils from "VSS/Utils/String";
import * as VSS from "VSS/VSS";
import {ViewContext} from "TestManagement/Scripts/TestReporting/Common/Common";
import { LicenseAndFeatureFlagUtils } from "TestManagement/Scripts/Utils/TFS.TestManagement.LicenseAndFeatureFlagUtils";

export interface ISignalRUrlData {
    connectionUrl: string;
}

export class RealTimeTestEvents {
    public static BUILD_TESTRUN_STATS_CHANGED: string = "BuildTestRunStatsChanged";
    public static RELEASE_TESTRUN_STATS_CHANGED: string = "ReleaseTestRunStatsChanged";
}

export class BuildEventArgs {
    buildId: number;
}

export class ReleaseEventArgs {
    releaseId: number;
    environmentId: number;
}

export function GetSignalRPageData(): ISignalRUrlData {
    const dataService: WebPageDataService = getService(WebPageDataService);
    const pageData = dataService.getPageData<ISignalRUrlData>("ms.vss-test-web.test-tab-signalr-data-provider");

    return pageData;
}

export class TestHubProxy {

    public static load(viewContext: ViewContext): IPromise<boolean> {
        let loaderPromise: Q.Deferred<boolean> = Q.defer<boolean>();
        if (TestHubProxy._loaded) {
            loaderPromise.resolve(true);
            return loaderPromise.promise;
        }

        const signalRScript = viewContext === ViewContext.Release ? "jquery.signalR-upd.2.2.0" : TestHubProxy.getSignalRScriptToLoadInBuildContext();

        if (!(<any>$).signalR) {
            VSS.requireModules([signalRScript]).then(
            () => {
                TestHubProxy._loadSignalRClient();
                loaderPromise.resolve(true);
            },
            (error: any) => {
                loaderPromise.reject(error);
            }
            );
        }
        else {
            TestHubProxy._loadSignalRClient();
            loaderPromise.resolve(true);
        }

        return loaderPromise.promise;
    }

    private static getSignalRScriptToLoadInBuildContext(): string {
        const tfsContext = TfsContext.getDefault();
        const thirdPartyUrl = tfsContext.configuration.get3rdPartyStaticRootPath();
        const minified = !Diag.getDebugMode() ? "min." : "";

       return StringUtils.format("{0}_scripts/jquery.signalR-upd.2.2.0.{1}js", thirdPartyUrl, minified);
    }

    public static getHubConnection(): any {
        return TestHubProxy._hubConnection;
    }

    public static getTestHubProxy(): any {
        return TestHubProxy._proxy;
    }

    private static _loadSignalRClient(): void {
        if (TestHubProxy._loaded) {
            return;
        }
        TestHubProxy._loaded = true;

        let signalRConfig: any = $;

        let pageContext: PlatformContracts.PageContext = VssContext.getPageContext();
        TestHubProxy._loadTcmTestHub(signalRConfig, pageContext);

    }

    private static _loadTcmTestHub(signalRConfig: any, pageContext: PlatformContracts.PageContext): void {
        if (LicenseAndFeatureFlagUtils.isUseSeparateAppPoolForTcmSignalREnabled()) {
            TestHubProxy._hubConnection = signalRConfig.hubConnection(this._getSignalRConnectionUrl(), { useDefaultPath: true });
        } else {
            TestHubProxy._hubConnection = signalRConfig.hubConnection(this._getSignalRConnectionUrl(), { useDefaultPath: false });
        }
        TestHubProxy._proxy = TestHubProxy._hubConnection.createHubProxy("testHub");
    }

    private static _getSignalRConnectionUrl(): string {
        const signalRPageData: ISignalRUrlData = GetSignalRPageData();
        if (signalRPageData && signalRPageData.connectionUrl) {
            if (LicenseAndFeatureFlagUtils.isUseSeparateAppPoolForTcmSignalREnabled()) {
                return signalRPageData.connectionUrl.split("/signalr")[0];
            } else {
                return signalRPageData.connectionUrl;
            }
        } else {
            return "signalr";
        }
    }

    private static _loaded: boolean = false;

    // The testHub connection copy of the $.connection.hub
    private static _hubConnection: any;
    private static _proxy: any;
}